const actionTypes = {
  UPDATE_EMAIL: "seneca/user/resetPassword/UPDATE_EMAIL"
};

export default actionTypes;
